import { useTranslation } from 'react-i18next';

import type { TipoRecibo } from './tiposRecibo';

export const EMOJI_TIPO: Record<TipoRecibo, string> = {
  luz: '💡',
  gas: '🔥',
  tele: '📱',
  suscripcion: '📺',
  'seguro-coche': '🚗',
  'seguro-hogar': '🏠',
  'seguro-salud': '🩺',
  tarjeta: '💳',
  otro: '📄',
};

/** Nombre de cada tipo de recibo, para la tarjeta «Contrato». */
export function useTextoTipo() {
  const { t } = useTranslation();
  return (tipo: TipoRecibo): string =>
    ({
      luz: t('Electricity'),
      gas: t('Gas'),
      tele: t('Mobile, internet or TV'),
      suscripcion: t('Subscription'),
      'seguro-coche': t('Car or motorbike insurance'),
      'seguro-hogar': t('Home insurance'),
      'seguro-salud': t('Health or life insurance'),
      tarjeta: t('Card or bank account'),
      otro: t('Something else'),
    })[tipo];
}
